module.exports = __webpack_public_path__ + "static/img/Simulations 2 - Numerical propagation.f259751.png";